const AiSessionList = () =>
  import(/* webpackChunkName: "AiSessionList" */ 'src/components/Dashboard/Views/AiSessions/AiSessionList.vue');

const AiSessionDetail = () =>
  import(/* webpackChunkName: "AiSessionDetail" */ 'src/components/Dashboard/Views/AiSessions/AiSessionDetail.vue');

export const aiSessionRoutes = [
  {
    path: 'ai-sessions/list/',
    name: 'List AI Sessions',
    component: AiSessionList,
  },
  {
    path: 'ai-sessions/view/:id',
    name: 'View AI Session',
    component: AiSessionDetail,
  },
];
